function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.87 4.94h8c.41 0 .75.34.75.75s-.34.75-.75.75h-8a4.26 4.26 0 00-4.25 4.25 4.26 4.26 0 004.25 4.25h11c.41 0 .75.34.75.75s-.34.75-.75.75h-11c-3.17 0-5.75-2.58-5.75-5.75S5.7 4.94 8.87 4.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.57 12.44c.19 0 .38.07.53.22l2.56 2.56c.29.29.29.77 0 1.06l-2.56 2.56c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l2.03-2.03-2.03-2.03a.754.754 0 010-1.06c.14-.15.34-.22.53-.22z"
})));